import { useState } from 'react';
import {
  AuthorizationServiceConfiguration, BaseTokenRequestHandler, FetchRequestor, GRANT_TYPE_REFRESH_TOKEN, TokenRequest, TokenResponse,
} from '@openid/appauth';
import { decodeJwt } from 'auth/jwt';
import environment from 'environment';
import { useInterval } from 'react-use';
import { useUserReadFacade } from 'redux/user-read/user-read.facade';
import { LoginUser } from 'types/model/user';

export const useTokenRefresh = () => {
  const {
    refreshToken, refreshInterval, idToken, setAccessToken, setUser, setIdToken, setRefreshToken,
  } = useUserReadFacade();
  const [error, setError] = useState<string|null>(null);

  useInterval(() => {
    // IDトークン未取得＝＝未ログインはレフレッシュを設定しない
    if (!idToken) { return; }

    // リフレッシュ間隔未設定＝＝未ログイン時はリフレッシュを設定しない
    if (refreshInterval <= 0) {
      return;
    }

    const initializeUser = (oResponse: TokenResponse) => {
      // ユーザー情報初期化
      setIdToken(oResponse.idToken || '');
      setAccessToken(oResponse.accessToken);
      setRefreshToken(oResponse.refreshToken || '');
      const user: LoginUser = decodeJwt(oResponse.accessToken);
      setUser(user);
    };

    const tokenHandler = new BaseTokenRequestHandler(new FetchRequestor());

    const tokenRequest = new TokenRequest({
      client_id: environment.clientId,
      redirect_uri: environment.redirectURL,
      grant_type: GRANT_TYPE_REFRESH_TOKEN,
      code: undefined,
      refresh_token: refreshToken,
    });

    // .well-knownエンドポイントからOIDCのエンドポイント情報を取得
    AuthorizationServiceConfiguration.fetchFromIssuer(environment.OPServer, new FetchRequestor())
      .then((oResponse) => {
        const configuration = oResponse;
        // トークンエンドポイントにアクセスし、アクセストークンを取得する
        return tokenHandler.performTokenRequest(configuration, tokenRequest);
      })
      .then((oResponse) => {
        initializeUser(oResponse);
      })
      .catch((oError) => {
        // エラーが発生したらリフレッシュを無効にする
        setError(oError.message || '');
      });
  }, error === null ? refreshInterval + 1000 : null);
};
